"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _comComponent = _interopRequireDefault(require("../../common/com-component"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    ComComponent: _comComponent.default
  },
  props: {
    id: {
      default: function _default() {
        return '3-2';
      }
    },
    keyId: {}
  },
  data: function data() {
    return {
      nullData: [{
        style_id: 'banner'
      }, {
        style_id: 'icon'
      }, {
        style_id: 'icon'
      }] //无数据时渲染静态的展示效果
    };
  },
  methods: {
    onLocation: function onLocation(url_config) {
      this.$refs.comComponent.onLocation(url_config);
    }
  }
};